import { ReactNode, useState } from "react";
import {
  Box,
  Collapse,
  IconButton,
  Stack,
  SxProps,
  Theme,
  Tooltip,
} from "@mui/material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CustomCard from "../CustomCard/CustomCard";
import CardTitleWithSubtitle from "../CardTitleWithSubtitle/CardTitleWithSubtitle";

interface CollapsibleFilterCardProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
  defaultExpanded?: boolean;
  cardSx?: SxProps<Theme>;
  padding?: number;
}

const CollapsibleFilterCard = ({
  title,
  subtitle,
  children,
  defaultExpanded = true,
  cardSx,
  padding = 2.4,
}: CollapsibleFilterCardProps) => {
  const [filtersExpanded, setFiltersExpanded] = useState(defaultExpanded);

  return (
    <CustomCard
      sx={{
        border: "1px solid #DFE0EB",
        boxShadow: "none",
        padding,
        ...cardSx,
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <CardTitleWithSubtitle
          title={title}
          subtitle={filtersExpanded ? subtitle : undefined}
        />
        <Tooltip
          title={filtersExpanded ? "Recolher Filtros" : "Expandir Filtros"}
        >
          <IconButton
            onClick={() => setFiltersExpanded(!filtersExpanded)}
            sx={{ ml: 2 }}
          >
            {filtersExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Tooltip>
      </Stack>

      <Collapse in={filtersExpanded}>
        <Box sx={{ pt: 2 }}>{children}</Box>
      </Collapse>
    </CustomCard>
  );
};

export default CollapsibleFilterCard;
